<button
  mat-button
  class="tw-text-sm tw-font-medium"
  [class.secondary]="headerOptions.secondary"
  [class.active]="active"
  [class.accent]="accent"
  [disableRipple]="true"
  (click)="click()">
  <ng-content></ng-content>
</button>

<ng-content select="app-options"></ng-content>
